import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=de437d64&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"
import style0 from "./softwareLis.vue?vue&type=style&index=0&id=de437d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de437d64",
  null
  
)

export default component.exports